module.exports = __webpack_public_path__ + "536c8f92ed495af0c63131b33a478793.MP3";